import { Chip as MUIChip, styled } from '@mui/material'
import useGetChipTemplate from '~/src/components/mui-wrappers/styled/chip/styles/useGetChipTemplate'

const Chip = styled(MUIChip)(() => useGetChipTemplate().getComponentSx())

export default Chip
